import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/kronik-bas-agrisi-tedavisinde-botoks/page.tsx");
